module.exports = __webpack_public_path__ + "img/oee-3.ac05d315.png";